import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { commandComponents } from './utils/appCommandComponents';
import { useCommandKeybindings } from './utils/useCommandKeybindings';
/** Represents a hook that sets up command keybindings and their handlers. */
export function useRegisterCommandHandlers() {
    const { newKeybindings } = useFeatureFlag(['new-keybindings']);
    useCommandKeybindings();
    return newKeybindings ? commandComponents : null;
}
